import styled, { keyframes, css } from "styled-components";

const pulseNeon = keyframes`
  0%, 100% {
    box-shadow: 0 0 8px #00D9FF, 0 0 16px #00D9FF;
  }
  50% {
    box-shadow: 0 0 12px #00D9FF, 0 0 24px #00D9FF;
  }
`;

export const TrackCardWrapper = styled.div<{ isActive?: boolean }>`
  width: 95%;
  max-width: 380px;
  border-radius: 20px;
  overflow: hidden;
  margin: 20px auto;
  transition: transform 0.3s ease;

  ${({ isActive }) =>
    isActive &&
    css`
      border: 2px solid #00d9ff;
      animation: ${pulseNeon} 2.5s infinite;
    `}

  &:hover {
    transform: translateY(-4px);
  }
`;

export const TrackCardTip = styled.div`
  width: 100%;
  color: ${({ theme }) => theme.THEME.grayText};
  padding: ${({ theme }) => theme.CONSTANTS.XH * 2}px;
`;

export const CoverWrapper = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
`;

export const CoverImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.72);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px;
  gap: 12px;
  text-align: center;
`;

export const InfoOverlay = styled.div`
  color: ${({ theme }) => theme.THEME.white};
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 40}px;
  font-weight: 700;
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 1}px;
  font-family: "Audiowide", sans-serif;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 10}px;
  }
`;

export const Controls = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;

  svg {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 42}px;
    color: ${({ theme }) => theme.THEME.white};
    cursor: pointer;
    transition: transform 0.2s ease;

    &:hover {
      transform: scale(1.2);
      color: ${({ theme }) => theme.THEME.neonBlue};
    }

    @media (min-width: 1025px) {
      font-size: ${({ theme }) => theme.CONSTANTS.XR * 10}px;
    }
  }
`;

export const SpotifyNotice = styled.div`
  margin-top: ${({ theme }) => theme.CONSTANTS.XH * 4};
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 22}px;
  color: #1db954;
  background-color: rgba(29, 185, 84, 0.1);
  padding: 4px 8px;
  border-radius: 4px;
  display: inline-block;
  font-family: "Inter", sans-serif;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 6}px;
  }
`;
